import React from 'react'
import './Heading.scss'

import { getCopyByGradeband } from '../../../../../services/ThemingService'
import { COPY_STRINGS } from '../../../../../constants/translatedCopy'

export default function Heading() {
  const copy_strings = getCopyByGradeband(COPY_STRINGS, "student_raise_hand"); 

  return (
    <div className="heading">
      <div className="heading__container">
        <div className="heading__line"></div>
        <div className="heading__title">{copy_strings.teacher_troubleshoot}</div>
        <div className="heading__line heading__line--right"></div>
      </div>
    </div>
  )
} 